import { createSelector } from 'reselect';

import options from './options';

const { name } = options;

export const getRegionsCatalog = state => state.models[name].regions.results;
export const getCurRegion = state => state.models[name].region;